import * as actionTypes from './actionTypes';
import { freeExtrachargeService } from './services';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchFreeExtrachargeRequest = () => ({
  type: actionTypes.FETCH_FREE_EXTRACHARGE_REQUEST
});

const fetchFreeExtrachargeSuccess = (data) => ({
  type: actionTypes.FETCH_FREE_EXTRACHARGE_SUCCESS,
  data
});

const fetchFreeExtrachargeFailure = () => ({
  type: actionTypes.FETCH_FREE_EXTRACHARGE_FAILURE
});

export const fetchFreeExtracharge = (categoryId: number): Function => {
  return async dispatch => {
    dispatch(fetchFreeExtrachargeRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await freeExtrachargeService.get(categoryId);
      dispatch(fetchFreeExtrachargeSuccess(data));
    } catch (e) {
      dispatch(fetchFreeExtrachargeFailure());
    }
  }
};
